import React,{Fragment} from "react";
import styles from './List.module.css';

const List = (props) => {
    return (
      <Fragment>
        <div className={styles.list}>
          <p className={styles.header}>{props.header}</p>
          <ul>
            {props.items.map((item, index) => (
              <li key={index}>{item}</li>
            ))}
          </ul>
        </div>
      </Fragment>
    );
}

export default List;